import React, { useEffect } from 'react'
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
    container: {
        display:'inline-block'
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 100
    }
}));

const SarasTimePicker = (props) => {
    const { value, step, id, onChange } = props
    const [time, setTime] = React.useState('')
    const classes = useStyles();

    const initializeValue = () => {
        // console.log('timer 4', value)
        if (value){
            // console.log("SarasTimePicker",value)
            setTime(value)
        }
            
    }

    useEffect(initializeValue, [value])

    const onTimeChange = (event) => {
        let value = event.target.value;
        // console.log('timer 3', value)
        setTime(value)
        if (onChange) onChange(event, value)
    }

    // console.log('timer 2',value, time)
    return (
        <form className={classes.container} noValidate>
            <TextField
                id={id}
                type="time"
                defaultValue={time}
                value={time}
                className={classes.textField}
                InputLabelProps={{
                    shrink: true
                }}
                inputProps={{
                    step: { step }
                }}
                onChange={onTimeChange}
            />
        </form>
    );
}

export default SarasTimePicker
